import React, { Fragment, useEffect, useState } from 'react';
import {
    faArrowRight,
    faPaperPlane,
    faHourglass,
    faPencilAlt,
    faCheck,
    faTimes,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { academicProgramsService } from '../../../../services';
import { Confirm } from '../../../blocks';
import eventEmitter from "../../../../shared/eventEmitter";

export const RequestLogHistory = ({
    requestLogs,
    requestStatus,
    userInput,
}) => {
    const [timelineData, setTimelineData] = useState(requestLogs);
    const [details, setDetails] = useState([]);
    const [confirmApprove, setConfirmApprove] = useState(false);
    const [confirmDeny, setConfirmDeny] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [confirmInstitution, setConfirmInstitution] = useState(false);
    useEffect(() => {
        setDetails(userInput ?? []);
    }, [userInput]);
    useEffect(() => {
        setTimelineData(requestLogs);
    }, [requestLogs]);
    const createTimelineGrouped = () => {
        console.log(details);
        const timeline = [];
        const logs = timelineData;
        if (logs == null || logs.length === 0) return timeline;
        const groupedData = logs.reduce((acc, item) => {
            if (!acc[item.timeStamp]) {
                acc[item.timeStamp] = [];
            }
            acc[item.timeStamp].push(item);
            return acc;
        }, {});
        Object.entries(groupedData).map(([timeStamp, logs]) => {
            if (logs.length === 1) {
                const log = logs[0];
                log.timeStamp = new Date(log.timeStamp).toLocaleDateString('en-US');
                timeline.push(
                    <li key={log.requestID} className="timeline-item">
                        {log.fieldName === 'createdOn' && (
                            <>
                                <div className="timeline-icon">
                                    <i className="far fa-paper-plane"></i>
                                </div>
                                <div className="timeline-content">
                                    <label className="text-600 d-block mb-3">
                                        {log.timeStamp} - Request Submitted
                                    </label>
                                    <p className="text-italic mb-0">
                                        Request type: {log.newFieldValue}
                                    </p>
                                </div>
                            </>
                        )}
                        {log.fieldName === 'statusId' && (
                            <>
                                <div className="timeline-icon bg-primary text-white">
                                    <i className="far">
                                        <FontAwesomeIcon icon={faHourglass} />
                                    </i>
                                </div>
                                <div className="timeline-content">
                                    <label className="text-600 d-block mt-1">
                                        {log.timeStamp} - Commission moved request to “
                                        {log.newFieldValue}”
                                    </label>
                                    <p className="text-italic mb-0">{log.comment}</p>
                                </div>
                            </>
                        )}
                        {log.fieldName === 'Merged Program Id' && (
                            <>
                                <div className="timeline-icon">
                                    <i className="far">
                                        <FontAwesomeIcon icon={faHourglass} />
                                    </i>
                                </div>
                                <div className="timeline-content">
                                    <p className="text-italic mb-0">
                                        Being merged with Program ID: {log.newFieldValue}.
                                        If approved, Program {log.newFieldValue} will be
                                        moved to status "Merged".
                                    </p>
                                </div>
                            </>
                        )}
                        {log.fieldName === 'comment' && (
                            <>
                                <div className="timeline-icon bg-primary text-white">
                                    <i className="far">
                                        <FontAwesomeIcon icon={faHourglass} />
                                    </i>
                                </div>
                                <div className="timeline-content">
                                    <label className="text-600 d-block mt-1">
                                        {log.timeStamp} - Commission sent back to
                                        institution for review
                                    </label>
                                    <p className="text-italic mb-0">
                                        {log.newFieldValue}
                                    </p>
                                </div>
                            </>
                        )}
                        {log.fieldName !== 'createdOn' &&
                            log.fieldName !== 'statusId' &&
                            log.fieldName !== 'comment' &&
                            log.fieldName !== 'Merged Program Id' && (
                                <>
                                    <div
                                        className={`timeline-icon ${
                                            log.cheAction ? 'bg-primary text-white' : ''
                                        }`}
                                    >
                                        <i className="far">
                                            <FontAwesomeIcon icon={faPencilAlt} />
                                        </i>
                                    </div>
                                    <div className="timeline-content">
                                        <label className="text-600 d-block mb-3">
                                            {log.timeStamp} - Submission{' '}
                                            {log.comment === 'initial'
                                                ? 'Created '
                                                : 'Edited '}
                                            {log.cheAction ? 'by Commission' : ''}
                                        </label>
                                        <h5 className="text-600 text-italic mb-2">
                                            {log.fieldName}
                                        </h5>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <div className="old-value">
                                                {log.oldFieldValue}
                                            </div>
                                            <div className="mx-3">
                                                <i className="far">
                                                    <FontAwesomeIcon
                                                        icon={faArrowRight}
                                                    />
                                                </i>
                                            </div>
                                            <div className="new-value">
                                                {log.newFieldValue}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </li>
                );
            } else {
                const timeStamp = new Date(logs[0].timeStamp).toLocaleDateString('en-US');
                const refLog = logs[0];
                timeline.push(
                    <li key={refLog.requestID} className="timeline-item">
                        <div
                            className={`timeline-icon ${
                                refLog.cheAction ? 'bg-primary text-white' : ''
                            }`}
                        >
                            <i className="far">
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </i>
                        </div>
                        <div className="timeline-content">
                            <label className="text-600 d-block mb-3">
                                {timeStamp} - Submission{' '}
                                {refLog.comment === 'initial' ? 'Created ' : 'Edited '}
                                {refLog.cheAction ? 'by Commission' : ''}
                            </label>
                            {logs
                                .filter(log => log.fieldName === 'Merged Program Id')
                                .map(log => (
                                    <>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <p className="text-italic mb-0">
                                                Being merged with Program ID:{' '}
                                                {log.newFieldValue}. If approved, Program{' '}
                                                {log.newFieldValue} will be moved to
                                                status "Merged".
                                            </p>
                                        </div>
                                    </>
                                ))}
                            {logs
                                .filter(
                                    log =>
                                        log.fieldName !== 'Additional Comments' &&
                                        log.fieldName !== 'Merged Program Id'
                                )
                                .map(log => (
                                    <>
                                        <h5 className="text-600 text-italic mb-2">
                                            {log.fieldName}
                                        </h5>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <div className="old-value">
                                                {log.oldFieldValue}
                                            </div>
                                            <div className="mx-3">
                                                <i className="far">
                                                    <FontAwesomeIcon
                                                        icon={faArrowRight}
                                                    />
                                                </i>
                                            </div>
                                            <div className="new-value">
                                                {log.newFieldValue}
                                            </div>
                                        </div>
                                    </>
                                ))}
                            {logs
                                .filter(log => log.fieldName === 'Additional Comments')
                                .map(log => (
                                    <>
                                        <h5 className="text-600 text-italic mb-2">
                                            {log.fieldName}
                                        </h5>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <p className="text-italic mb-0">
                                                {log.newFieldValue}
                                            </p>
                                        </div>
                                    </>
                                ))}
                        </div>
                    </li>
                );
            }
        });
        return timeline;
    };

    const getDeliveryMode = deliveryMode => {
        if (deliveryMode === null || deliveryMode === undefined) return null;
        if (deliveryMode === 'On Campus & Online') {
            return 3;
        } else if (deliveryMode === 'On Campus Only') {
            return 1;
        } else {
            return 2;
        }
    };

    const changeStatus = (statusId, commentsForInstitution = '') => {
        const logs = requestLogs;
        if (logs == null || logs.length === 0) return false;
        const refLog = logs[0];
        console.log(details);
        const locationStatusChanges = details.locations
            ? details.locations.map(location => {
                  return {
                      LocationId: location.locationId,
                      LocationName: location.locationName,
                      StatusId: 1,
                  };
              })
            : null;
        const postData = {
            degreeLevel: details.degreeLevelId ? details.degreeLevelId : undefined,
            programId: details.programID ? details.programID : -1,
            locationStatusChanges: locationStatusChanges,
            formalName: details.programName ? details.programName : undefined,
            cipCode: details.cipCode ? details.cipCode : undefined,
            distanceEdApproved: {
                id: getDeliveryMode(details.deliveryMode),
            },
            comments: details.comments ? details.comments : commentsForInstitution,
            creditRequirementMinimum: details.creditRequirementMinimum
                ? Number(details.creditRequirementMinimum)
                : undefined,
            creditRequirementMaximum: details.creditRequirementMaximum
                ? Number(details.creditRequirementMaximum)
                : undefined,
            institutionId: details.institution ? details.institution.value : undefined,
            credential: {
                ProgramURL: details.programURL ? details.programURL : '',
                Keywords: details.keywords ? details.keywords : '',
                ProgramDescription: details.description ? details.description : '',
                CredentialName: details.programName ? details.programName : undefined,
            },
            ProgramStatusId: details.programStatus,
        };
        const res = academicProgramsService.changeProgramRequestStatus(
            refLog.requestId,
            statusId,
            postData
        );
        Promise.resolve(res).then(data => {
            eventEmitter.emit('updateSARData')
            const res2 = academicProgramsService.getProgramRequestLogs(refLog.requestId);
            Promise.resolve(res2).then(data => {
                const wrappedData = { requestLogs: data };
                setTimelineData(data);
            });
        });
    };
    return (
        <Fragment>
            <section className="request-history">
                <h5 className="text-muted mb-4">Request History</h5>
                <div className="timeline-container">
                    <ul className="history-timeline">{createTimelineGrouped()}</ul>
                </div>
                <div className="request-actions">
                    <div className="d-flex justify-content-end">
                        <button
                            type="button"
                            data-toggle="modal"
                            data-target="#sendBackModal"
                            className="btn btn-outline-primary mr-3"
                            disabled={
                                requestStatus === 'Approved' || requestStatus === 'Denied'
                            }
                            onClick={() => {
                                setConfirmInstitution(true);
                            }}
                        >
                            <i className="fas fa-undo"></i> Send Back for Institution
                            Review
                        </button>
                        <button
                            type="button"
                            data-toggle="modal"
                            data-target="#approveConfirmModal"
                            className="btn btn-success mr-3 px-3"
                            disabled={
                                requestStatus === 'Approved' || requestStatus === 'Denied'
                            }
                            onClick={() => {
                                setConfirmApprove(true);
                            }}
                        >
                            <i className="far"></i> <FontAwesomeIcon icon={faCheck} />{' '}
                            Approve
                        </button>
                        <button
                            type="button"
                            data-toggle="modal"
                            data-target="#denyConfirmModal"
                            className="btn btn-danger px-3"
                            onClick={() => {
                                setConfirmDeny(true);
                            }}
                            disabled={
                                requestStatus === 'Approved' || requestStatus === 'Denied'
                            }
                        >
                            <i className="far"></i> <FontAwesomeIcon icon={faTimes} />{' '}
                            Deny
                        </button>
                        <button
                            type="button"
                            data-toggle="modal"
                            data-target="#deleteConfirmModal"
                            className="btn btn-warning mr-3 px-3"
                            disabled={
                                requestStatus === 'Approved' || requestStatus === 'Denied'
                            }
                            onClick={() => {
                                setConfirmDelete(true);
                            }}
                        >
                            <i className="far"></i> <FontAwesomeIcon icon={faTrash} />{' '}
                            Delete
                        </button>
                    </div>
                </div>
            </section>
            <Confirm
                isOpen={confirmApprove}
                toggle={() => {
                    setConfirmApprove(false);
                }}
                onConfirm={() => {
                    changeStatus(3);
                }}
                title="Confirm Changes"
                message="Are you sure you want to approve this request?"
            />
            <Confirm
                isOpen={confirmDeny}
                toggle={() => {
                    setConfirmDeny(false);
                }}
                onConfirm={() => {
                    changeStatus(4);
                }}
                title="Confirm Changes"
                message="Are you sure you want to deny this request?"
            />
            <Confirm
                isOpen={confirmDelete}
                toggle={() => {
                    setConfirmDelete(false);
                }}
                onConfirm={() => {
                    changeStatus(6);
                }}
                title="Confirm Delete"
                message="Are you sure you want to delete this request?"
            />
            <Confirm
                isOpen={confirmInstitution}
                toggle={() => setConfirmInstitution(false)}
                onConfirm={input => changeStatus(5, input)}
                title="Send back to institution"
                message=""
                addTextBox={true}
                textBoxTitle="Comments"
            />
        </Fragment>
    );
};
